import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

// Confirmation dialog for Update & Sync: choose the standard queue sync or the
// Shopify bulk-operations sync. Closes with 'queue', 'bulk', or undefined
// (cancel).
@Component({
  selector: 'app-sync-mode-dialog',
  templateUrl: './sync-mode-dialog.component.html',
  styleUrls: ['./sync-mode-dialog.component.scss']
})
export class SyncModeDialogComponent {
  // Bulk is the default — large runs accidentally submitted on the queue lane
  // take hours instead of minutes. The last explicit choice is remembered.
  public mode: 'queue' | 'bulk' =
    (localStorage.getItem('syncModePreference') as 'queue' | 'bulk') || 'bulk';

  constructor(private dialogRef: MatDialogRef<SyncModeDialogComponent>) {}

  public confirm(): void {
    localStorage.setItem('syncModePreference', this.mode);
    this.dialogRef.close(this.mode);
  }

  public cancel(): void {
    this.dialogRef.close();
  }
}
